module.exports = __webpack_public_path__ + "static/media/silkycloud-black-3.be8a0eef.png";